<template>
  <div class="wlx-site-manager-wrapper">
    <header class="site-manager-head-con">
      <el-form :inline="true" size="small">
        <el-form-item>
         <el-input v-model="search" size="small" style="width:220px;" placeholder="输入关键字搜索"/>
        </el-form-item>
      </el-form>
    </header>
    <el-table
      :data="enrollList.filter(data => !search || data.Title.toLowerCase().includes(search.toLowerCase()))"
      style="width: 100%"
    >
      <el-table-column label="标题" prop="Title"></el-table-column>
      <el-table-column label="学员" prop="DisplayName"></el-table-column>
      <el-table-column label="学校" prop="SchoolName"></el-table-column>
      <el-table-column label="学号" prop="Number"></el-table-column>
      <el-table-column label="手机号" prop="Mobile"></el-table-column>
      <el-table-column label="身份证号" prop="IDNumber" width="200"></el-table-column>
      <el-table-column label="站点" prop="SiteName"></el-table-column>
      <el-table-column label="报名时间" prop="DateCreated"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <div style="color: #2D82FF" v-if="scope.row.IsAdop==0">等待处理</div>
          <div style="color: #05C94F" v-if="scope.row.IsAdop==1">已通过</div>
          <div style="color: #E53939" v-if="scope.row.IsAdop==2">未通过</div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">审核</el-button>
          <el-button size="mini" @click="lookImg(scope.row)">查看</el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column align="right">
        <template slot="header" slot-scope="scope"></template>
      </el-table-column> -->
    </el-table>
    <div class="u-page-con">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :append-to-body="true"
      :before-close="handleClose"
      :close-on-click-modal="false">
      <el-radio-group v-model="IsAdopt">
        <el-radio :label="1">通过</el-radio>
        <el-radio :label="2">不通过</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false;isShow = false" style="position: absolute;right: 106px;top: 113px;">取 消</el-button>
        <SynthesisImg
          v-if="dialogVisible"
          :file.sync="file"
          :userIdentifier="UserIDNumber"
          :identifier="CertificateIdentifier"
          :name="Title"
          :desc="CreateDisplayName"
          :cover="UserCoverUrl"
          :DateCreated="DateCreated"
          :AttestationId="AttestationId"
          :stuId="stuId"
          :IsAdopt="IsAdopt"
          :joinAttestationId="joinAttestationId"
          v-on:onClick="clickChild"
        ></SynthesisImg>
      </span>
    </el-dialog>
    <div v-if="imgShow" style="width:100%;height:100%;position: fixed;top:0;left:0;z-index:3000;background:#808080;">
      <img v-show="imgurl!=''" id="canvasImg" style="width:100%;height:100%;" :src="imgurl" @click="imgShow=false;"/>
    </div>
  </div>
</template>

<script>
import SynthesisImg from "page/component/SynthesisImg/SynthesisImg.vue";
export default {
  data() {
    return {
      enrollList: [],
      search: "",
      pageIndex: 1,
      pageSize: 10,
      totalCount: 10,
      dialogVisible: false,
      IsAdopt: 0,
      joinAttestationId: "",
      dialogVisiblecer: false,
      stuId: "",
      file: "",
      AttestationId: "",
      Id: "",
      AttestationId: "",
      CreateUserId: "",
      CreateDisplayName: "",
      Title: "",
      CertificateIdentifier: "",
      DateCreated: "",
      UserCoverUrl: "",
      UserIDNumber: "",
      imgShow:false,
      imgurl:""
    };
  },
  props: {},
  components: {
    SynthesisImg
  },
  computed: {},
  created() {
    this.getAttestationListall();
  },
  methods: {
    clickChild(isShow){
      debugger;
      this.dialogVisible = isShow;
      this.getAttestationListall();
    },
    lookImg(event){
      this.imgurl=event.CertificateCover;
      this.imgShow=true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogVisiblecer = false;
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getAttestationListall(); 
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.getAttestationListall();
    },
    handleEdit(val) {
      this.CreateDisplayName = val.DisplayName;
      this.Title = val.Title;
      this.CertificateIdentifier = val.Random;
      this.DateCreated = val.DateCreated;
      this.UserCoverUrl = val.UserCoverUrl == null ? "" : val.UserCoverUrl;
      this.UserIDNumber = val.UserIDNumber == null ? "" : val.UserIDNumber;

      this.joinAttestationId = val.Id;
      this.stuId = val.CreateUserId;
      this.AttestationId = val.AttestationId;
      this.dialogVisible = true;
    },
    Random() {
      var str = "";
      for (var i = 0; i < 15; i++) {
        var randnum = this.rand(0, 10);
        str += randnum;
      }
      return str;
    },
    rand(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    },
    shenhe() {
      if (this.IsAdopt == 2) {
        this.dialogVisible = false;
        var that = this;
        this.$http.post("/api/XOrg/StudentManager/updateIsAdopt", {
            Id: this.joinAttestationId,
            IsAdopt: 2
          }).then(function(rst) {
            if (rst.code > 0) {
              that.$message.success(rst.msg);
              
            } else {
              that.$message.warning(rst.msg);
            }
          });
      }
      if (this.IsAdopt == 1) {
        this.dialogVisible = false;
        this.dialogVisiblecer = true;
      }
    },
    GoToYes() {
      var that = this;
      this.$http.post("/api/XOrg/StudentManager/addCertificate", {
          userId: this.stuId,
          url: this.file,
          AttestationId: this.AttestationId,
          CertificateIdentifier:this.CertificateIdentifier
        }).then(function(rst) {
          if (rst.code > 0) {
          } else {
          }
        });
      that.$http.post("/api/XOrg/StudentManager/updateIsAdopt", {
          Id: that.joinAttestationId,
          IsAdopt: 1
        }).then(function(res) {
          if (res.code > 0) {
            that.$message.success(res.msg);
            that.dialogVisiblecer = false;
            that.getAttestationListall();
          } else {
            that.$message.warning(res.msg);
          }
        });
    },
    getAttestationListall() {
      var that = this;
      this.$http.post("/api/XOrg/StudentManager/getAttestationListall", {
          type: 3,
          page: this.pageIndex
        }).then(function(rst) {
          if (rst.code > 0) {
            that.enrollList = rst.enrollList;
            that.pageIndex = rst.pagination.pageIndex;
            that.pageSize = rst.pagination.pageSize;
            that.totalCount = rst.pagination.totalCount;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  }
};
</script>